module.exports = __webpack_public_path__ + "media/images/icon/icons8-Logout Rounded Down Filled-8a4a644d8e6723e01f06fa2bb1e917e1.png";